import { iterator as Symbol_iterator } from '../symbol/iterator';
import { isFunction } from './isFunction';
export function isIterable(input) {
  return isFunction(input === null || input === void 0 ? void 0 : input[Symbol_iterator]);
}
